import {
    MeasurementUnitsDto,
    UnitConverter,
    Conversion as ConversionType
} from '@swegon/ahud-buildingblocks-utility';

class Conversion {
    measurementUnitsDto: MeasurementUnitsDto;
    unitConverter: UnitConverter;

    constructor(measurementUnitsDto: MeasurementUnitsDto) {
        this.measurementUnitsDto = measurementUnitsDto;
        this.unitConverter = new UnitConverter(measurementUnitsDto);
    }

    getConversionKey = (key: string) => {
        switch (key) {
            case 'm3s':
            case 'm3_s':
                return 'CubicMeterPerSecond';
            case 'm3h':
            case 'm3_h':
                return 'CubicMeterPerHour';
            case 'ls':
            case 'l_s':
                return 'LiterPerSecond';
            case 'cfm':
            case 'feet3_min':
                return 'CubicFeetPerMinute';
            default:
                return 'CubicMeterPerSecond';
        }
    };

    getMathcingConversionData = (newUnitKey: string) => {
        const matchingConversion = this.measurementUnitsDto?.ct_conversion.find(
            (conversion: ConversionType) =>
                conversion.guiUnitType === 'airFlow' &&
                conversion.guiUnit === this.getConversionKey(newUnitKey)
        );
        if (!matchingConversion) {
            throw Error(`Unsupported unit ${newUnitKey}`);
        }
        const conversionData = {
            ...matchingConversion,
            projectUnit: matchingConversion.projectFileUnit
        };
        return conversionData;
    };

    convertFromM3s = (unitKey: string, value: number) => {
        if (!this.measurementUnitsDto) {
            return value;
        }
        const conversionData = this.getMathcingConversionData(unitKey);
        const visualValue = parseFloat(
            String(this.unitConverter.convert(conversionData, value))
        );
        return visualValue;
    };

    convertToM3s = (unitKey: string, value: number) => {
        if (!this.measurementUnitsDto) {
            return value;
        }
        if (unitKey === 'm3s' || unitKey === 'm3_s') {
            return value;
        }
        const conversionData = this.getMathcingConversionData(unitKey);
        const actualValue = parseFloat(
            String(this.unitConverter.convertBack(conversionData, value))
        );
        return actualValue;
    };

    convertFromAnyToAny = (fromUnit: string, toUnit: string, value: number) => {
        const valueInM3s = this.convertToM3s(fromUnit, value);
        const valueInNewUnit = this.convertFromM3s(toUnit, valueInM3s);
        return valueInNewUnit;
    };
}

export default Conversion;
